import { Trans } from '@lingui/react'

import BorderedText from 'views/components/atoms/BorderedText'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import { RED_POINTS_MODAL_ID } from 'views/consts'
import { redPointsType } from 'views/utils/propTypes'
import { shouldRenderLabel } from 'views/utils/redPointsUtils'

const ProductLabelRedPoint = ({ redPointsData }) => {
  return redPointsData && shouldRenderLabel(redPointsData) ? (
    <li className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabel__red-points o-ProductLabels__ProductLabelContainer">
      <ModalShowButton
        modalId={RED_POINTS_MODAL_ID}
        component={ButtonAsLink}
        name="red-points-modal-button"
      >
        <BorderedText
          bgcolor="negative-extraVariation"
          bordercolor="negative"
          color="red"
          dataQaId={redPointsData.multiplierRP}
        >
          <div className="l-flex a-Flag__red-points">
            {redPointsData.multiplierRP}x <Trans id="general.label.redPoints" />
            <div className="u-padding-x-small--left l-flex a-Flag__red-points__icon-container">
              <IconCircleInfoOutline size="x-small" />
            </div>
          </div>
        </BorderedText>
      </ModalShowButton>
    </li>
  ) : null
}

ProductLabelRedPoint.propTypes = {
  redPointsData: redPointsType,
}

ProductLabelRedPoint.defaultProps = {
  redPointsData: null,
}

export default ProductLabelRedPoint
